import CoreuiVue from '@coreui/vue'
import axios from 'axios'
import 'core-js/stable'
import { extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import { between, double, email, max, max_value, min, required } from 'vee-validate/dist/rules'
import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import ja from '../definition/ja.json'
import App from './App'
import { iconsSet as icons } from './assets/icons/icons.js'
import axiosErrorHandler from './common/axiosErrorHandler'
import router from './router'
import store from './store'
var format = require('string-format');
format.extend(String.prototype, {});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver );
Vue.component('v-select', vSelect);
Vue.prototype.$axios = axios;
axiosErrorHandler(axios); 
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

// VeeValidateがデフォルトで用意している各ルールを使用するよう指定
extend('required', required);　//必須
extend('email', email); //メールアドレス
extend('max_value', max_value);　//数値かつ上限
extend('max', max); //最大文字数
extend('min', min); //最小文字数
extend('double', double); //小数値
extend('between', between); //最小値～最大値の値
localize('ja', ja) //エラーメッセージの日本語化用

// VeeValidateカスタムルール
const period = {
  params: [{
    name: 'From',
    isTarget: true
  }],
  validate(value, {From}) {
    return new Date(From) <= new Date(value);
  }
}
extend('period', period); //期間From<To

const minLabelList = {
  params: [{
    name: 'min',
  }],
  validate(value, {min}) {
    return value >= min;
  }
}
extend('minLabelList', minLabelList); //期間From<To

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
